import { useSelector } from "react-redux";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";
import DateInput from "../../../components/common/inputs/DateInput";
import UserModal from "../../../components/common/modals/user-modal/UserModal";
import { useRef, useState } from "react";
import { successMessage } from "../../../utils/toastify-message/ToastifyMessage";
import { PiXFill } from "react-icons/pi";

export default function AllOrderReportsFilter({ filterDataHandler }) {
  const { utils } = useSelector(utilsState);
  const userModalRef = useRef();

  const [user, setUser] = useState(null);

  const handleUser = (data) => {
    setUser(data.name);
    successMessage(`کاربر ${data?.name} انتخاب شد`);
    filterDataHandler({ page: 1, user: data?._id });
  };

  const deleteUser = () => {
    setUser("");
    filterDataHandler({ page: 1, user: "" });
  };

  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <UserModal ref={userModalRef} handleUser={handleUser} />

      <div className="admin-filter-grid">
        <div className="w-full min-w-0">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            شناسه محصول
          </label>
          <div class="relative w-full">
            <div class="absolute z-[1] inset-y-0 left-0 flex items-center px-3 pointer-events-none">
              <svg
                class="w-5 h-5 text-gray-500 dark:text-gray-400"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </div>
            <input
              type="text"
              id="table-search"
              class="block p-2 pe-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-full bg-white/50 backdrop-blur-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="جست و جو ..."
              onChange={(e) =>
                filterDataHandler({ page: 1, sku: e.target.value })
              }
            />
          </div>
        </div>
        <div className="relative">
          <span
            onClick={() => userModalRef?.current?.showModal()}
            className="absolute w-full h-full"
          ></span>
          {user ? (
            <PiXFill
              className=" cursor-pointer absolute left-2 bottom-4 text-red-500"
              onClick={deleteUser}
            />
          ) : null}
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            انتخاب کاربر
          </label>
          <input
            value={user}
            onChange={(e) => setUser(e.target.value)}
            disabled
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          />
        </div>
        <div className="relative">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            وضعیت پرداخت
          </label>
          <select
            onChange={(e) =>
              filterDataHandler({ page: 1, paymentStatus: e.target.value })
            }
            className="backdrop-blur block w-full sm:w-auto p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50/50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700/70 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value={""}>{"وضعیت پرداخت"}</option>
            <option value={""}>{"همه"}</option>
            {utils &&
              utils?.PAYMENT_STATUS_VALUES.map((item) => {
                if (item.value == utils?.PAYMENT_STATUS?.done?.value) {
                  return <option value={item.value}>{item.name}</option>;
                } else {
                  return <option value={item.value}>{item.name}</option>;
                }
              })}
          </select>
        </div>
        <label className="flex flex-col gap-2 text-sm dark:text-white">
          نام، موبایل یا شماره سفارش
          <input type="text" className="admin-field" onChange={(e) => filterDataHandler({ searchText: e.target.value })} />
        </label>
        <label className="flex flex-col gap-2 text-sm dark:text-white">
          وضعیت ارسال
          <select className="admin-field" onChange={(e) => filterDataHandler({ proccessShipping: e.target.value })}>
            <option value="">همه</option>
            {utils?.ORDER_PROCCESS_SHIPPING_STATUS_VALUES?.map((item) => <option key={item.value} value={item.value}>{item.name}</option>)}
          </select>
        </label>
        <label className="flex flex-col gap-2 text-sm dark:text-white">
          ترتیب
          <select className="admin-field" onChange={(e) => filterDataHandler({ sort: e.target.value })}>
            <option value="-paymentDate">جدیدترین پرداخت</option>
            <option value="paymentDate">قدیمی‌ترین پرداخت</option>
          </select>
        </label>
        <DateInput
          label={"از تاریخ"}
          onChange={(e) => filterDataHandler({ page: 1, from: e })}
        />
        <DateInput
          label={"تا تاریخ"}
          onChange={(e) => filterDataHandler({ page: 1, to: e })}
        />
      </div>
    </div>
  );
}
